<template>
<div>
    <button class="no-print">imprimir</button>
  <br />
  <body style="font-family: Arial; font-size: 13.5px;">
    <div class="print-container clearfix">
          <div class="flex-container">
            <div style="flex-grow: 1">
              <img id ="img1" class="invoice-logo" src="../../assets/img/logo2.png" alt=""  />
            </div>
          </div>
          <div class="flex-container">
            <div style="flex-grow: 6">
              <h5 style="text-align: center; padding-top: 18px; font-size: 20px">PUNTOS DE MEDICIÓN DE SISTEMA DE PROTECCIÓN CATÓDICA (P.M.)</h5>
            </div>
          </div>

          <b-container class="bv-example-row">
            <b-row>
              <b-col sm style= "border: 1px solid #000;">Código: FLD-MNT-RE-065</b-col>
              <b-col sm style= "border: 1px solid #000;">Versión: 01</b-col>
              <b-col sm style= "border: 1px solid #000;">Fecha:   </b-col>
            </b-row>
          </b-container>
    </div>
    <div class="print-container clearfix" >
        <div>
            <b-card-group deck>
              <b-card bg-variant="Secondary" text-variant="dark" header="Sistema" class="text-center">
                <b-card-text style = "text-align: center;"> SIST. PROT. CATÓDICA </b-card-text>
              </b-card>

              <b-card bg-variant="Secondary" text-variant="dark" header="Locación" class="text-center">
                <b-card-text style = "text-align: center;">{{getPropDisplay(locacion)}}</b-card-text>
              </b-card>

              <b-card bg-variant="Secondary" text-variant="dark" header="Descripción de la Actividad" class="text-center">
                <b-card-text style = "text-align: center;"> Medicion de Potencial ON </b-card-text>
              </b-card>

              <b-card bg-variant="Secondary" text-variant="dark" header="Fecha" class="text-center">
                <b-card-text style = "text-align: center;">{{fecha}} </b-card-text>
              </b-card>
              <b-card bg-variant="Secondary" text-variant="dark" header="Ubicación" class="text-center">
                <b-card-text style = "text-align: center;">{{ubicacion}}</b-card-text>
              </b-card>
            </b-card-group>
          </div>
    </div>

    <div class="print-container clearfix" >
      <div>
        <b-card-group deck>
          <b-card bg-variant="Secondary" text-variant="dark" header="Método Utilizado" class="text-center">
            <b-card-text style = "text-align: center;">NACE Standard SP0169-2013 "Control of External Corrosion on Underground of Submerged Metallic Piping Systems"</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Equipo Utilizado" class="text-center">
            <b-card-text style = "text-align: center;">Multímetro Digital Fluke 115 N/S 18620883<br>Electrodo de Cobre sulfato de Cobre(CSE)</b-card-text>
          </b-card>
        </b-card-group>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div>
      <!-- <div v-if="metadata.comentarios!=null"> -->
        <span><b>Observaciones</b></span>
      </div>
      <div v-if = "typeof observaciones === 'string'">
        <b-form-textarea
          id="textarea-plaintext"
          size = "sm"
          plaintext :value= "observaciones"
          rows="3"
          max-rows="6">
        </b-form-textarea>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div>
      <!-- <div v-if="metadata.comentarios!=null"> -->
        <span><b>Recomendaciones</b></span>
      </div>
      <div v-if = "typeof recomendaciones === 'string'">
        <b-form-textarea
          id="textarea-plaintext"
          size = "sm"
          plaintext :value= "recomendaciones"
          rows="3"
          max-rows="6">
        </b-form-textarea>
      </div>
    </div>

    <div class="print-container clearfix">
      <div>
      <!-- <div v-if="inspection.image"> -->
        <span><b>Registro Fotográfico</b></span>
      </div>
      <div class="flex-container" style="center">
        <div style="flex-grow: 1">
        </div>
        <div style="flex-grow: 1">
          <b-img thumbnail fluid v-for="(image, key, i) in catodico.image" v-bind:key="'img4_'+i" :id="'img4_'+i"
          style="max-height:400px" class="img-fluid" :src="loadedFiles[key]" alt="Ninguno" :title="key" />
        </div>
        <div style="flex-grow: 1">
        </div>
      </div>
    </div>

    <div class="print-container clearfix" >
      <div>
        <b-card-group deck>
          <b-card bg-variant="Secondary" text-variant="dark" header="Supervisor de Protección Catódica" class="text-center">
            <b-card-text style = "text-align: center;"></b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Jefe de Obra" class="text-center">
            <b-card-text style = "text-align: center;"></b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Surpevior" class="text-center">
            <b-card-text style = "text-align: center;"></b-card-text>
          </b-card>
        </b-card-group>
      </div>
    </div>
  </body>
</div>
</template>

<script>
import Base from '../Base.vue'
import AttachmentsLoader from '../auxx/AttachmentsLoader'
import store from '../../store'
import Vue from 'vue'
export default {
  extends: Base,
  watch: {
    db (to, from) {
      if (to) {
        this.loadCatodico()
      }
    }
  },
  data () {
    return {
      catodico: {},
      codigo: {},
      observaciones: {},
      recomendaciones: {},
      locacion: {},
      fecha: {},
      ubicacion: {},
      attachmentsLoader: null
    }
  },
  computed: {
    loadedFiles () {
      if (this.attachmentsLoader) {
        return this.attachmentsLoader.loadedFiles
      }
      return {}
    }
  },
  methods: {
    onCancel () {
      let obj = this
      obj.$router.push({ name: 'list', params: { typex: this.$route.params.typex, json: obj.$route.params.json } })
    },
    loadCatodico () {
      let obj = this
      if (this.$route.params.id !== '0' && this.$route.params.id !== 0) {
        obj.getdata(this.$route.params.id, true).then(function (data) {
          let AttachmentsLoaderClass = Vue.extend(AttachmentsLoader)
          obj.attachmentsLoader = new AttachmentsLoaderClass({
            router: obj.$router,
            store,
            propsData: {
              idx: obj.$route.params.id,
              vattachments: { ...data.image }
            }
          })
          obj.$set(obj, 'catodico', data)
          obj.$set(obj, 'codigo', data)
          obj.$set(obj, 'observaciones', data)
          obj.$set(obj, 'recomendaciones', data)
          obj.$set(obj, 'locacion', data)
          obj.$set(obj, 'fecha', data)
          obj.$set(obj, 'ubicacion', data)

          obj.observaciones = obj.observaciones.observations
          obj.recomendaciones = obj.recomendaciones.recomendations
          obj.locacion = obj.locacion.identification.location.flowline
          obj.fecha = obj.fecha.identification.date
          obj.ubicacion = obj.ubicacion.identification.location.progressive
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    getPropDisplay (name, defaults = '') {
      if (this.metadata.identification) {
        let choices = this.metadata.identification.children.location.choices
        for (var i in choices) {
          if (choices[i].value === name) {
            return choices[i].display_name
          }
        }
      } else { return defaults }
    }
  }
}

</script>

<style>
li{
  margin: 0px;
  padding: 0px;
}
ul{
  margin: 0px;
  padding: 0px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
th, td {
  text-align: left;
  padding-left: 6px;
  padding-right: 6px;
}
.flex-container {
  display: flex;
  justify-content: stretch;
}
.flex-container > div {
  width: auto;
  margin: 0px;
  text-align: center;
  line-height: 35px;
  font-size: 14px;
  justify-content: center;
}
.invoice-logo {
  height: 50px;
  width: auto;
}
tr:nth-child(even){background-color: #fff}
.print-container {
    max-width: 1250px;
    margin: 5px auto;
    background: white;
    padding: 2px 30px;

  }
  .print-container .header {
    margin-bottom: 0px;
    border-bottom: 0px solid #dbdbdb;
    padding-bottom: 0px;
  }
  .print-container table {
    margin-top: 0px;
  }
  .print-container table tbody tr.no-border:first-child {
    opacity: 0.6 !important;
  }
  .print-container .summary-table {
    border: 1px solid #DDE1E4;
  }
  .print-container .summary-table tr td:last-child {
    text-align: right;
  }
  .print-container .summary-table tr th:last-child {
    text-align: right;
  }
  .print-container .summary-table td {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table th {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table thead {
    color: #737F8B;
    text-transform: uppercase;
  }
  .print-container .ft-18 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .print-container .adder {
    font-size: 16px;
    font-weight: 500;
    text-align: right;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }
  .print-container .total {
    font-size: 22px;
  }
  .print-container .mega {
    font-size: 33px;
    margin-bottom: 10px;
  }
  .row {
    margin-left: 0.0px;
  }
  .card-header{
    font-weight: bold;
  }
  @media print {
    h1, h2, h3, h4, h5, h6 {
      font-weight: bold;
    }
    h1:first-letter, h2:first-letter, h3:first-letter, h4:first-letter, h5:first-letter, h6:first-letter {
      font-size: inherit;
    }
  }
</style>
